import Filters from "./filters";
import Table from "./table";

const PodInvoice = () => {
  return (
    <>
      <div className="app-content-header">
        <div style={{ width: "100%", padding: "12px 24px" }}>
          <Filters />
        </div>
      </div>
      <div className="nav-page-content">
        <Table />
      </div>
    </>
  );
};

export default PodInvoice;
